<template>
    <div class="content" style="padding:0;">

        <div class="card-header">
            <div class="row">

                <div class="col-xl-3 col-lg-4 col-sm-6 mb-2">
                    <label>{{$t("accounting.account.province")}}</label>
                    <select class="form-control" v-model="filter.province"
                            @change="onProvinceGetRegionsChange">
                        <option value=""></option>
                        <option :value="option" v-for="option in provinces" :key="option.id">
                            {{option.name}}
                        </option>
                    </select>
                </div>

                <div class="col-xl-3 col-lg-4 col-sm-6 mb-2">
                    <label>{{$t("accounting.account.city")}} ва
                        {{$t("accounting.account.district")}}</label>
                    <select class="form-control" v-model="filter.region">
                        <option value=""></option>
                        <option :value="option" v-for="option in regions" :key="option.id">
                            {{option.name}}
                        </option>
                    </select>
                </div>

                <div class="col-xl-2 col-lg-3 col-md-3 col-sm-6 mb-2">
                    <label>{{$t("report.date.startDate")}}</label>
                    <datepicker
                            class="form-control"
                            format="dd/MM/yyyy"
                            v-model="filter.startDate"
                            :clear-button="true"
                    ></datepicker>
                </div>

                <div class="col-xl-2 col-lg-3 col-md-3 col-sm-6 mb-2">
                    <label>{{$t("report.date.endDate")}}</label>
                    <datepicker
                            class="form-control"
                            format="dd/MM/yyyy"
                            v-model="filter.endDate"
                            :clear-button="true"
                    ></datepicker>
                </div>

                <div class="col-xl-3 col-lg-4 col-md-6 col-sm-6 mb-2">
                    <label>{{$t("report.field.objectType")}}</label>
                    <select v-model="filter.objectType" class="form-control">
                        <option disabled value="">{{$t("messages.combo.empty")}}</option>
                        <option value="Auto" style="font-family:verdana;">Автотранспорт</option>
                        <option value="Building">Бино-иншоатлар</option>
                        <option value="Fitment">Асбоб-ускуналар</option>
                    </select>
                </div>

                <div class="col-sm-1">
                    <label style="align-self: center">{{$t("main.search")}}</label>
                    <button class="all-btn m-0 form-control" @click="initList"
                            style="color: #fff;background-color: #00bcd4;border-color: #00bcd4;
                                        box-shadow: 0 2px 2px 0 rgba(0, 188, 212, .14),
                                        0 3px 1px -2px rgba(0, 188, 212, .2),
                                        0 1px 5px 0 rgba(0, 188, 212, .12)">
                        <i class="fa fa-search"></i>
                    </button>
                </div>
            </div>
        </div>

        <div class="box">
            <vue-scrolling-table
                    :scroll-horizontal="scrollHorizontal"
                    :scroll-vertical="scrollVertical"
                    :sync-header-scroll="syncHeaderScroll"
                    :sync-footer-scroll="syncFooterScroll"
                    :include-footer="includeFooter"
                    :dead-area-color="deadAreaColor"
                    :class="{ freezeFirstColumn:freezeFirstColumn }">
                <template slot="thead" class="table-head">
                    <tr>
                        <th colspan="9"></th>
                        <th colspan="2">{{$t("accounting.account.invoice")}}</th>
                        <th colspan="2">{{$t("report.field.car")}}</th>
                        <th colspan="2">{{$t("report.field.fitment")}}</th>
                        <th colspan="2">{{$t("report.field.building")}}</th>
                        <th colspan="2">{{$t("report.field.payment")}}</th>
                    </tr>
                    <tr>
                        <th v-for="col in columns"
                            :class="col.cssClasses"
                            :key="col.id">{{ col.title }}
                        </th>
                    </tr>
                </template>
                <template slot="tbody">
                    <tr v-for="item in items" :key="item.id">
                        <td v-for="col in columns"
                            :class="col.cssClasses"
                            :key="col.id">{{ item[col.id] }}
                        </td>
                    </tr>
                </template>
                <template slot="tfoot">
                    <tr>
                        <th :colspan="columns.length">
                            Бахоланган объектлар сони: {{totals}}
                            &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                            Жами сумма: {{tableTotalValue.contractTotal}}
                            &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                            Кредитор: {{tableTotalValue.creditorTotal}}
                            &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                            Дебитор: {{tableTotalValue.debtorTotal}}
                        </th>
                    </tr>
                </template>
            </vue-scrolling-table>
        </div>
    </div>
</template>
<script>
    import Datepicker from 'vuejs-datepicker';
    import VueScrollingTable from "vue-scrolling-table"
    import initFilterModel from '@/shared/filter';
    import {formatDate, parseDate} from '@/shared/utils';
    // export const
    export default {
        name: "ReportMIB",
        components: {
            VueScrollingTable,
            Datepicker,
        },
        data: function () {
            return {
                loading: false,
                filter: initFilterModel(),
                scrollVertical: true,
                scrollHorizontal: true,
                syncHeaderScroll: true,
                syncFooterScroll: true,
                includeFooter: true,
                deadAreaColor: "#DDDDDD",
                maxRows: 10000,
                totals: 0,
                freezeFirstColumn: false,
                regions: [],
                provinces: [],
                tableTotalValue: [],
                columns: [
                    {id: "number", title: this.$t("main.number"), cssClasses: "col-auto"},
                    {id: "id", title: this.$t("report.field.objectNumber"), cssClasses: "col-auto"},
                    {id: "clientName", title: this.$t("report.field.organization"), cssClasses: "col-auto"},
                    {id: "provinceName", title: this.$t("report.field.province"), cssClasses: "col-auto"},
                    {id: "regionName", title: this.$t("report.field.district"), cssClasses: "col-auto"},
                    {id: "debtorName", title: this.$t("report.field.ownerClient"), cssClasses: "col-auto"},
                    {id: "name", title: this.$t("report.field.name"), cssClasses: "col-auto"},
                    {id: "autoGovernmentNum", title: this.$t("report.field.governmentNum"), cssClasses: "col-auto"},
                    {id: "employeName", title: this.$t("realEstate.field.evaluator"), cssClasses: "col-auto"},
                    {id: "numberContract", title: this.$t("accounting.account.number"), cssClasses: "col-auto"},
                    {id: "date", title: this.$t("accounting.account.date"), cssClasses: "col-auto"},
                    {id: "autoQty", title: this.$t("report.field.quantity"), cssClasses: "col-auto"},
                    {id: "autoPrice", title: this.$t("report.field.evaluationPrice"), cssClasses: "col-auto"},
                    {id: "fitmentQty", title: this.$t("report.field.quantity"), cssClasses: "col-auto"},
                    {id: "fitmentPrice", title: this.$t("report.field.evaluationPrice"), cssClasses: "col-auto"},
                    {id: "buildingQty", title: this.$t("report.field.quantity"), cssClasses: ""},
                    {id: "buildingPrice", title: this.$t("report.field.evaluationPrice"), cssClasses: ""},
                    {id: "paid", title: this.$t("report.field.paid"), cssClasses: ""},
                    {id: "unpaid", title: this.$t("report.field.unpaid"), cssClasses: ""},
                ],
                allItems: [],
            }
        },


        methods: {
            initList() {
                this.loading = true;
                this.filter.organizationType = "BUREAU_OF_COMPULSORY_EXECUTION";
                this.init();
                this.initTableTotal();
                this.filter.startDate = formatDate(this.filter.startDate);
                this.filter.endDate = formatDate(this.filter.endDate);

                this.filter.startDate = parseDate(this.filter.startDate);
                this.filter.endDate = parseDate(this.filter.endDate);
                this.$http.post('report/list/legal/client/type', this.filter)
                    .then(res => {
                        this.allItems = res.data.data;
                        console.log(this.allItems);
                        this.totals = res.data.total;
                    }, err => {
                        console.log(err);
                        this.loading = false;
                    });
            },
            initTableTotal() {
                const vm = this;
                const promises = [
                    this.$http.post('/account/list/data/total', this.filter)
                ];
                Promise.all(promises).then(function (values) {
                    const initData = values[0].data;
                    vm.tableTotalValue = initData.dataTotal;

                });
            },
            init() {
                const vm = this;
                const promises = [
                    this.$http.get('province/init')
                ];
                Promise.all(promises).then(function (values) {
                    const initData = values[0].data;
                    vm.provinces = initData.provinces;
                });
            },
            onProvinceGetRegionsChange() {
                let regions = [];
                if (this.filter.province && this.filter.province.id && this.provinces && this.provinces.length > 0) {
                    this.provinces.forEach((province) => {
                        if (province.id === this.filter.province.id) {
                            regions = province.regions;
                        }
                    });
                }
                this.regions = regions;
            },
        },

        created() {
            this.initList();
        },


        computed: {
            items() {
                return this.allItems.slice(0, this.maxRows)
            },
        },
    }
</script>
<style>
    table.scrolling .w2 {
        width: 20em;
        min-width: 20em;
        max-width: 20em;
    }

    table.scrolling tfoot tr th {
        width: 130em;
        min-width: 130em;
        max-width: 130em;
        border-spacing: 0;
        border-collapse: collapse;
    }

    table.freezeFirstColumn thead tr,
    table.freezeFirstColumn tbody tr {
        display: block;
        width: min-content;
    }

    table.freezeFirstColumn thead td:first-child,
    table.freezeFirstColumn tbody td:first-child,
    table.freezeFirstColumn thead th:first-child,
    table.freezeFirstColumn tbody th:first-child {
        position: sticky;
        position: -webkit-sticky;
        left: 0;
    }

    * {
        font-family: sans-serif;
    }

    .box {
        clear: both;
        padding: 0;
        min-height: 740px;
        height: 40vh;
        margin-left: auto;
        margin-right: auto;
        overflow: hidden;
    }

</style>

